"use client";

// A SERVER ACTION FROM BEFORE A RELEASE, CAUGHT BY ITS CALLER.
//
// Next salts every server action's id with a key it makes per build, so after
// a deploy an open tab's actions are unknown to the new server, and the call
// rejects with UnrecognizedActionError. Most callers let that rejection reach
// the error boundary or the window's unhandledrejection listener, both of
// which take reloadIfStale's one reload (lib/stale-build.ts). A few catch it
// themselves, because the same catch also stands for a dropped connection, and
// they said "check the connection": false, and nothing the reader does fixes
// it. Those catches ask here for the true sentence.
//
// No reload from here: each of those callers holds typing its failed save did
// not send (a weekly report's box, a campaign form), so the reader is told to
// copy it first. The reply box's draft autosave is one more (message-leaves):
// it did not catch at all, so a stale tab's save while somebody typed a reply
// went to unhandledrejection and reloadIfStale reloaded the page under them,
// words and all. It now catches this one failure, and only this one.

import { unstable_isUnrecognizedActionError } from "next/navigation";

export const STALE_ACTION_TEXT = "The app was updated since this page opened, so that didn't reach it. Copy anything you typed, then reload the page.";

/** Is this a server action the server no longer knows: this tab is from before a release? */
export function isStaleAction(err: unknown): boolean {
  return unstable_isUnrecognizedActionError(err);
}

/** What a caught server-action failure should say: the stale-build sentence when it is one, else `otherwise`. */
export function caughtActionText(err: unknown, otherwise: string): string {
  return isStaleAction(err) ? STALE_ACTION_TEXT : otherwise;
}
